import React, { Component } from 'react'
import ShareCam from './ShareCam'
import ShareLink from './ShareLink'
import Alert from '../etc/Alert'
import Creater from '../../controller/Creater'
import './style.css'


export default class Share extends Component {

    constructor() {
        super()
        this.state = {
            openCam : false,
            openLink : false,
            fileName : '',
            isAlert : false
        }
    }


    // 이벤트 리스너 가비지 컬렉션 필요


    componentDidMount() {

        let dropArea = document.getElementById('shareIconBox')

        const foo = ['dragenter', 'dragover', 'dragleave', 'drop']
        const bar = ['dragenter', 'dragover']
        const toe = ['dragleave', 'drop']
        
        foo.forEach(eventName => {
          dropArea.addEventListener(eventName, this.preventDefaults, false)   
          document.body.addEventListener(eventName, this.preventDefaults, false)
        })
        
        bar.forEach(eventName => {
            dropArea.addEventListener(eventName, this.highlight, false)
        })
  
        toe.forEach(eventName => {
            dropArea.addEventListener(eventName, this.unhighlight, false)
        })
    
        dropArea.addEventListener('drop', this.handleDrop, false)

    }

    preventDefaults = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }


    highlight = (e) => {
        document.getElementById('shareIconBox').classList.add('highlight')
    }
    
    unhighlight = (e) => {
        document.getElementById('shareIconBox').classList.remove('highlight')
    }

    handleDrop = (e) => {
        const dt = e.dataTransfer
        const files = dt.files
        this.handleFiles(files)
    }

    handleFiles = (files) => {
        files = [...files]
        files.forEach(this.attachFx)
    }

    attachFx = (file) => {

        const data = new FormData()

        data.append('file', file)

        let condition = {
            url : '/api/memo/attach',
            data : data
            
        }

        Creater(condition, res => {

            if(res.message === 'ERROR') {

                this.setState({
                    isAlert : true
                })

            } else {

                this.setState({
                    fileName : file.name,
                    openLink : true
                })

            }
        })
       
    }

    camFx = () => {

        this.setState(
            { openCam : true }
        )
        
    }

    closeFx = () => {

        this.setState({
            openCam : false,
            openLink: false,
            isAlert : false
        })

    }


    render() {

		const Banner = {
			backgroundImage: 'url("/share.jpg")',
			height: '100vh'
        }

		return (

            <div className='WideContainer' style={Banner}>
                { this.state.isAlert ? <Alert alert = 'ERROR' closeMe = { this.closeFx } /> : null }        
                { this.state.openCam ? <ShareCam closeMe = {this.closeFx} /> : null } 
                { this.state.openLink ? <ShareLink fileName = {this.state.fileName} closeMe = {this.closeFx} /> : null }


                <div id='shareIconBox'>

                    <form class='dropForm'>
                        <input type='file' id='fileElem' multiple accept='image/*' style={{display: 'none'}} onchange='handleFiles(this.files)' />              
                    </form>

                    <div id='dropBox'>
                        <i className='material-icons dropIcon'>save_alt</i>
                        <p id='dropTxt'>DROP HERE</p>
                    </div>

                </div>

                <div id='shareMenu'>
                    <i className='material-icons' onClick={this.camFx}>photo_camera</i>
                    <span onClick={this.camFx}>WEBCAM</span>
                </div>

                <span id='shareNote'>
                The idea and design of this page are heavily inspired by PASTEBOARD (https://pasteboard.co/).
                </span>

            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/share/index.js